/**
 * Sends an email notification by calling our secure Vercel Serverless Function.
 * This avoids CORS issues and keeps the API key hidden.
 * @param {'yes' | 'no' | 'think'} answer - Zainab's response.
 * @param {string} message - Zainab's personalized message.
 */
export const sendResponseEmail = async (answer, message) => {
  try {
    const response = await fetch("/api/send-email", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ answer, message }),
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("API Error:", data);
      return { success: false, error: data };
    }

    console.log("Email request processed:", data);
    return { success: true, data };
  } catch (error) {
    console.error("Failed to call email service:", error);
    return { success: false, error: error.message };
  }
};
